import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import { Reveal, SectionKicker } from "@/components/Reveal";
import SEO from "@/components/SEO";
import { container } from "@/lib/constants";

const PRINCIPLES = [
  ["Discretion", "We operate quietly. Opportunities are shared on a need-to-know basis, and identities are protected on both sides of every introduction."],
  ["Independence", "We are not a broker chasing volume. We are aligned with principals and answer only to the mandate in front of us."],
  ["Institutional rigour", "Every counterparty is verified. Every deal is documented. Every access grant is recorded and auditable."],
];

export default function About() {
  return (
    <PublicLayout>
      <SEO title="About the desk" description="The philosophy of Prime Deal Gateway: discretion, independence, and institutional rigour." />
      <section className={`${container} py-20 lg:py-28`}>
        <Reveal>
          <SectionKicker>The desk</SectionKicker>
          <h1 className="pdg-serif text-4xl sm:text-5xl text-foreground max-w-3xl leading-[1.08]">
            A private desk, built for principals who value what is not advertised.
          </h1>
          <p className="mt-8 text-lg text-foreground/80 max-w-2xl leading-8">
            Prime Deal Gateway exists to connect verified principals with off-market European
            opportunities that never reach an open market. We are deliberately small, deliberately
            discreet, and deliberately selective.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {PRINCIPLES.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.06}>
              <GlassCard className="p-8 h-full">
                <h2 className="pdg-serif text-2xl text-foreground">{t}</h2>
                <p className="mt-4 text-sm text-muted-foreground leading-7">{d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 max-w-3xl">
            <div className="pdg-hairline w-24 mb-8" />
            <p className="text-base text-foreground/75 leading-8">
              We do not publish the names of our team or our members. The desk speaks with a single,
              institutional voice &mdash; because the work is about the opportunity and the principal, not
              about us. Our reputation is held privately, among the counterparties who already know it.
            </p>
          </div>
        </Reveal>
      </section>
    </PublicLayout>
  );
}
